import useGameId from '@/hooks/useGameId'
import useSubscription from '@/hooks/useSubscription'
import { useAppDispatch } from '@/redux/store'
import { Topics } from '@/redux/store/common/topic'
import { hiloActions } from '@/redux/store/modules/hilo'
import React, { useEffect } from 'react'

export default function ConfigHiloSubscription() {
  const dispatch = useAppDispatch()
  const game_id = useGameId()

  const _message = useSubscription(Topics.configRound(game_id))
  const message = _message?.message?.message

  useEffect(() => {
    if (!message) return
    try {
      const data = JSON.parse(message.toString() || '')
      dispatch(hiloActions.updateConfigRound(data))
    } catch (error) {
      console.warn('ConfigHiloSubscription error: ', error)
    }
  }, [message])

  return <></>
}
